export const RequiredMessage = 'Required field';
export const MaxCharMessage = 'Maximum characters exceeds';
export const MaxCharMessageFunction = (textLimit: number) =>
  `Must not exceed ${textLimit} characters`;
export const DigitsOnlyMessage = 'Must be only digits';
export const EmailMessage = 'Invalid Email';
export const AlphanumericMessage = 'Must be alphanumeric';
export const TextMessage = 'Invalid Characters';
export const NotBlankMessage = 'Must not contain blank spaces';
